var map = {
	"./API/Index.vue": 4618,
	"./API/Partials/ApiTokenManager.vue": 4771,
	"./Auth/ConfirmPassword.vue": 5546,
	"./Auth/ForgotPassword.vue": 4522,
	"./Auth/Register.vue": 9541,
	"./Auth/ResetPassword.vue": 6200,
	"./Auth/TwoFactorChallenge.vue": 997,
	"./Auth/TwoFactorChallenge_bk.vue": 2891,
	"./Auth/VerifyEmail.vue": 7381,
	"./Common/login.vue": 5255,
	"./Common/manual.vue": 1753,
	"./Common/menu.vue": 7413,
	"./Common/menu_wo_inertia.vue": 1041,
	"./Common/reissue-password.vue": 2806,
	"./Common/two-factor-authentification.vue": 9330,
	"./Common/update_email.vue": 525,
	"./Common/user-information.vue": 8534,
	"./Components/DownloadModal.vue": 4099,
	"./Components/Title.vue": 5260,
	"./Components/TranslationButton.vue": 9475,
	"./Components/TranslationOptions copy.vue": 4834,
	"./Components/TranslationOptions.vue": 3620,
	"./Components/contextMenu.vue": 767,
	"./Components/footer.vue": 4426,
	"./Components/modal.vue": 1025,
	"./Dashboard.vue": 2137,
	"./JVTA/Client/ClientCreate.vue": 4695,
	"./JVTA/Client/ClientEdit.vue": 277,
	"./JVTA/Client/ClientIndex.vue": 460,
	"./JVTA/Client/ClientShow.vue": 7836,
	"./JVTA/Inquiry/InquiryCreate.vue": 1640,
	"./JVTA/Inquiry/InquiryIndex.vue": 1741,
	"./JVTA/Message/MessageCreate.vue": 9299,
	"./JVTA/Message/MessageEdit.vue": 7963,
	"./JVTA/Message/MessageIndex.vue": 5448,
	"./JVTA/Message/MessageShow.vue": 6946,
	"./JVTA/login_jvta.vue": 1659,
	"./JVTA/menu_jvta.vue": 7200,
	"./Management/contract.vue": 5298,
	"./Management/group_detail.vue": 2109,
	"./Management/team.vue": 4699,
	"./Management/user.vue": 8438,
	"./PrivacyPolicy.vue": 8328,
	"./Profile/Partials/DeleteUserForm.vue": 1027,
	"./Profile/Partials/LogoutOtherBrowserSessionsForm.vue": 3606,
	"./Profile/Partials/TwoFactorAuthenticationForm.vue": 3157,
	"./Profile/Partials/UpdatePasswordForm.vue": 1698,
	"./Profile/Partials/UpdateProfileInformationForm.vue": 5379,
	"./Profile/Show.vue": 1531,
	"./Teams/Create.vue": 145,
	"./Teams/Partials/CreateTeamForm.vue": 4758,
	"./Teams/Partials/DeleteTeamForm.vue": 824,
	"./Teams/Partials/TeamMemberManager.vue": 6178,
	"./Teams/Partials/UpdateTeamNameForm.vue": 6699,
	"./Teams/Show.vue": 4431,
	"./TermsOfService.vue": 7503,
	"./Translation/App/FileTranslate.vue": 214,
	"./Translation/App/PostEdit.vue": 7464,
	"./Translation/App/TextTranslate.vue": 3230,
	"./Translation/Glossaries/Edit.vue": 6724,
	"./Translation/Glossaries/Index.vue": 972,
	"./Translation/TranslatedBilingualFiles/ArchivedFilesIndex.vue": 4178,
	"./Translation/TranslatedBilingualFiles/Index.vue": 4119,
	"./Translation/Video/ArchivedIndex.vue": 62,
	"./Translation/Video/CreateAndUpdate.vue": 2960,
	"./Translation/Video/Index.vue": 274,
	"./Welcome.vue": 7270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1230;